import React, { useState, useRef } from 'react';
import styles from './packages.module.css';
import Services from '../../assets/forTellUsWhatYouNeed.jpg';
import { useTranslation } from 'react-i18next';
import { message, Modal } from "antd";

// API Configuration
const API_BASE_URL = 'https://api.geoglobalgate.com/api';
const API_ENDPOINT = `${API_BASE_URL}/requests`;

// Currency options
const CURRENCIES = [
  { code: 'GEL', symbol: '₾', name: 'Georgian Lari' },
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'EUR', symbol: '€', name: 'Euro' }
];

// Customs office data
const CUSTOMS_OFFICES = {
  departure: [
    { code: "GEBCP001", name: 'BCP "Tbilisi Airport"' },
    { code: "GEBCP002", name: 'BCP "Tsiteli Khidi"' },
    { code: "GEBCP003", name: 'BCP "Sadakhlo – Motorway"' },
    { code: "GEBCP004", name: 'BCP "Sadakhlo – Railway"' },
    { code: "GEBCP005", name: 'BCP "Guguti"' },
    { code: "GEBCP007", name: 'BCP "Samtatskaro"' },
    { code: "GEBCP009", name: 'BCP "Gardabani"' },
    { code: "GEBCP010", name: 'BCP "Lagodekhi"' },
    { code: "GEBCP021", name: 'BCP "Mtkvari"' },
    { code: "GEBCP101", name: 'BCP "Kazbegi"' },
    { code: "GEBCP301", name: 'BCP "Vale"' },
    { code: "GEBCP302", name: 'BCP "Ninotsminda"' },
    { code: "GEBCP309", name: 'BCP "Kartsakhi – Akhalkalaki Railway"' },
    { code: "GEBCP320", name: 'BCP "Kartsakhi"' },
    { code: "GEBCP401", name: 'BCP "Kutaisi and Senaki Airports"' },
    { code: "GEBCP501", name: 'BCP "Poti Sea Port"' },
    { code: "GEBCP504", name: 'BCP "new sea port of Poti"' },
    { code: "GEBCP601", name: 'BCP "Sarpi"' },
    { code: "GEBCP604", name: 'BCP "Batumi Sea Port"' },
    { code: "GECCD014", name: "CCD Rustavi" },
    { code: "GECCD017", name: "CCD Telavi" },
    { code: "GECCD300", name: "CCD Akhaltsikhe" },
    { code: "GECCD400", name: "CCD Kutaisi" },
    { code: "GECCZ111", name: "CCZ Tbilisi" },
    { code: "GECCZ112", name: "CCZ Batumi" },
    { code: "GECCZ113", name: "CCZ Poti" },
    { code: "GECCZ114", name: "CCZ Airport" },
    { code: "GECCZ115", name: "CCZ Tbilisi 2" },
    { code: "GECCZ116", name: "CCZ Tbilisi 2" },
    { code: "GECCZ117", name: "CCZ E-GEZ" },
    { code: "GECSA050", name: "CSA Rustavi" },
    { code: "GECSA070", name: "CSA Telavi" },
    { code: "GECSA250", name: "CSA Gori" },
    { code: "GECSA350", name: "CSA Akhaltsikhe" },
    { code: "GECSA450", name: "CSA Kutaisi" },
    { code: "GECSA510", name: "CSA Poti" },
    { code: "GECSA511", name: "CSA Zugdidi" },
    { code: "GECSA555", name: "CSA Ozurgeti" },
    { code: "GECSA605", name: "CSA Batumi" },
    { code: "GEFIZ110", name: 'FIZ "Tbilisi Technology Park"' },
    { code: "GEFIZ403", name: "FIZ KUTAISI" },
    { code: "GEFIZ404", name: "FIZ hualing Kutaisi" },
    { code: "GEFIZ503", name: "FIZ POTI" }
  ],
  entry: [
    { code: "GEBCP002", name: 'BCP "Tsiteli Khidi"', city: "Marneuli municipality" },
    { code: "GEBCP003", name: 'BCP "Sadakhlo – Motorway"', city: "Marneuli municipality" },
    { code: "GEBCP004", name: 'BCP "Sadakhlo – Railway"', city: "Marneuli municipality" },
    { code: "GEBCP005", name: 'BCP "Guguti"', city: "Dmanisi municipality" },
    { code: "GEBCP009", name: 'BCP "Gardabani"', city: "Gardabani municipality" },
    { code: "GEBCP010", name: 'BCP "Lagodekhi"', city: "Lagodekhi municipality" },
    { code: "GEBCP101", name: 'BCP "Kazbegi"', city: "Kazbegi municipality" },
    { code: "GEBCP301", name: 'BCP "Vale"', city: "Adigeni municipality" },
    { code: "GEBCP302", name: 'BCP "Ninotsminda"', city: "Ninotsminda municipality" },
    { code: "GEBCP309", name: 'BCP "Kartsakhi–Akhalkalaki Railway"', city: "Akhalkalaki municipality" },
    { code: "GEBCP320", name: 'BCP "Kartsakhi"', city: "Akhalkalaki municipality" },
    { code: "GEBCP501", name: 'BCP "Poti Sea Port"', city: "Poti" },
    { code: "GEBCP502", name: 'BCP "Kulevi Sea Port"', city: "Village Kulevi" },
    { code: "GEBCP504", name: 'BCP "new sea port of Poti"', city: "Poti" },
    { code: "GEBCP601", name: 'BCP "Sarpi"', city: "Khelvachauri municipality" },
    { code: "GEBCP604", name: 'BCP "Batumi Sea Port"', city: "Batumi" },
    { code: "GECCD014", name: "CCD Rustavi", city: "Rustavi" },
    { code: "GECCD017", name: "CCD Telavi", city: "Telavi" },
    { code: "GECCD300", name: "CCD Akhaltsikhe", city: "Akhaltsikhe" },
    { code: "GECCD400", name: "CCD Kutaisi", city: "Kutaisi" },
    { code: "GECCZ111", name: "CCZ Tbilisi", city: "Gardabani municipality" },
    { code: "GECCZ112", name: "CCZ Batumi", city: "Khelvachauri municipality" },
    { code: "GECCZ113", name: "CCZ Poti", city: "Poti" },
    { code: "GECCZ114", name: "CCZ Airport", city: "Tbilisi" },
    { code: "GECCZ115", name: "CCZ Tbilisi 2", city: "Gardabani municipality" }
  ]
};

// Required files configuration
const getRequiredFiles = (t) => ({
  export: [
    { key: 'cmr', labelKey: 'cmr', required: true },
    { key: 'declaration', labelKey: 'declaration', required: true },
    { key: 'invoice', labelKey: 'invoice', required: true },
    { key: 'packingList', labelKey: 'packingList', required: true },
    { key: 'vehicleRegistration', labelKey: 'vehicleRegistration', required: true },
    { key: 'driverPassport', labelKey: 'driverPassport', required: true }
  ],
  transit: [
    { key: 'registrationCertificate', labelKey: 'registrationCertificate', required: true },
    { key: 'declaration', labelKey: 'declaration', required: true },
    { key: 'invoice', labelKey: 'invoice', required: true },
    { key: 'packingList', labelKey: 'packingList', required: true },
    { key: 'cmr', labelKey: 'cmr', required: true },
    { key: 'vehicleRegistration', labelKey: 'vehicleRegistration', required: true },
    { key: 'driverPassport', labelKey: 'driverPassport', required: true }
  ]
});

function Packages() {
  const { t } = useTranslation();
  const fileInputRefs = useRef({});

  const [formData, setFormData] = useState({
    company_name: "",
    name: "",
    email: "",
    phone: "",
    car_number: "",
    service: "",
    shipmentPrice: "",
    currency: "", // Added currency field
    // Export fields
    evaluationCustomsOffice: "",
    exitCustomsOfficeExport: "",
    // Transit fields
    entryCustomsOffice: "",
    exitCustomsOfficeTransit: "",
    // Common fields
    route: "",
    finalClearanceLocation: "",
    message: "",
  });

  // Changed to store arrays of files for each document type
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [status, setStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [animatingFiles, setAnimatingFiles] = useState({}); // Track animating files
  const [termsAccepted, setTermsAccepted] = useState(false); // Terms acceptance state
  const [termsModalVisible, setTermsModalVisible] = useState(false); // Terms modal visibility
  const [successModalVisible, setSuccessModalVisible] = useState(false); // Success modal visibility

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Clear error for this field
    if (errors[name]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }

    // Reset files when service type changes
    if (name === 'service') {
      setUploadedFiles({});
      // Reset file inputs
      Object.keys(fileInputRefs.current).forEach(key => {
        if (fileInputRefs.current[key]) {
          fileInputRefs.current[key].value = '';
        }
      });
    }
  };

  // Updated to handle multiple files with animation
  const handleFileChange = (fileKey, e) => {
    const files = Array.from(e.target.files);
    
    if (files.length === 0) return;

    // Validate each file
    const validFiles = [];
    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
    const MAX_TOTAL_SIZE = 50 * 1024 * 1024; // 50MB total limit
    
    let totalSize = 0;
    
    // Calculate existing files size for this key
    if (uploadedFiles[fileKey]) {
      totalSize = uploadedFiles[fileKey].reduce((sum, file) => sum + file.size, 0);
    }

    for (const file of files) {
      if (file.size > MAX_FILE_SIZE) {
        message.error(`${t('fileTooBig')}: ${file.name} (max 5MB)`);
        continue;
      }
      
      if (totalSize + file.size > MAX_TOTAL_SIZE) {
        message.error(`${t('totalSizeExceeded')} (max 50MB)`);
        break;
      }
      
      // Add unique ID for animation tracking
      file.uniqueId = `${file.name}_${Date.now()}_${Math.random()}`;
      validFiles.push(file);
      totalSize += file.size;
    }

    if (validFiles.length > 0) {
      // Trigger animation for new files
      validFiles.forEach(file => {
        setAnimatingFiles(prev => ({
          ...prev,
          [`${fileKey}_${file.uniqueId}`]: 'adding'
        }));
      });

      setUploadedFiles(prev => ({
        ...prev,
        [fileKey]: [...(prev[fileKey] || []), ...validFiles]
      }));

      // Clear animation state after animation completes
      setTimeout(() => {
        validFiles.forEach(file => {
          setAnimatingFiles(prev => {
            const newState = { ...prev };
            delete newState[`${fileKey}_${file.uniqueId}`];
            return newState;
          });
        });
      }, 500);

      // Success feedback
      message.success(`${validFiles.length} ${t('filesAddedSuccess')}`);

      // Clear file errors
      if (errors.files) {
        setErrors(prev => {
          const newErrors = { ...prev };
          delete newErrors.files;
          return newErrors;
        });
      }
    }

    // Reset input to allow selecting the same files again if needed
    e.target.value = '';
  };

  // Remove a single file from a document type with animation
  const removeFile = (fileKey, fileIndex) => {
    const fileToRemove = uploadedFiles[fileKey][fileIndex];
    const animKey = `${fileKey}_${fileToRemove.uniqueId}`;
    
    // Start removal animation
    setAnimatingFiles(prev => ({
      ...prev,
      [animKey]: 'removing'
    }));

    // Remove file after animation
    setTimeout(() => {
      setUploadedFiles(prev => {
        const newFiles = { ...prev };
        if (newFiles[fileKey]) {
          newFiles[fileKey] = newFiles[fileKey].filter((_, index) => index !== fileIndex);
          if (newFiles[fileKey].length === 0) {
            delete newFiles[fileKey];
          }
        }
        return newFiles;
      });

      // Clean up animation state
      setAnimatingFiles(prev => {
        const newState = { ...prev };
        delete newState[animKey];
        return newState;
      });
    }, 300);
  };

  // Remove all files for a document type with animation
  const removeAllFiles = (fileKey) => {
    const files = uploadedFiles[fileKey] || [];
    
    // Start removal animation for all files
    files.forEach(file => {
      const animKey = `${fileKey}_${file.uniqueId}`;
      setAnimatingFiles(prev => ({
        ...prev,
        [animKey]: 'removing-all'
      }));
    });

    // Remove all files after animation
    setTimeout(() => {
      setUploadedFiles(prev => {
        const newFiles = { ...prev };
        delete newFiles[fileKey];
        return newFiles;
      });

      // Clean up all animation states
      setAnimatingFiles(prev => {
        const newState = { ...prev };
        files.forEach(file => {
          delete newState[`${fileKey}_${file.uniqueId}`];
        });
        return newState;
      });

      message.info(t('allFilesRemoved'));
    }, 400);
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  };

  const showRouteInfo = () => {
    Modal.info({
      title: t('routeInfoTitle'),
      content: t('routeInfoContent'),
      okText: t('routeInfoButton')
    });
  };

  const showTermsModal = () => {
    setTermsModalVisible(true);
  };

  const handleTermsModalClose = () => {
    setTermsModalVisible(false);
  };

  const handleTermsChange = (e) => {
    setTermsAccepted(e.target.checked);
    // Clear terms error if exists
    if (errors.terms) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors.terms;
        return newErrors;
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // Validate required fields
    if (!formData.company_name) newErrors.company_name = t("companyNameRequired");
    if (!formData.name) newErrors.name = t("nameRequired");
    if (!formData.email) newErrors.email = t("emailRequired");
    if (!formData.phone) newErrors.phone = t("phoneRequired");
    if (!formData.car_number) newErrors.car_number = t("carNumberRequired");
    if (!formData.service) newErrors.service = t("serviceRequired");
    if (!formData.shipmentPrice) newErrors.shipmentPrice = t("shipmentPriceRequired");
    if (!formData.currency) newErrors.currency = t("currencyRequired"); // Added currency validation

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.email && !emailRegex.test(formData.email)) {
      newErrors.email = t("invalidEmail");
    }

    // Service-specific field validation
    if (formData.service === 'export') {
      if (!formData.evaluationCustomsOffice) newErrors.evaluationCustomsOffice = t("evaluationCustomsRequired");
      if (!formData.exitCustomsOfficeExport) newErrors.exitCustomsExport = t("exitCustomsExportRequired");
    }

    if (formData.service === 'transit') {
      if (!formData.entryCustomsOffice) newErrors.entryCustomsOffice = t("entryCustomsRequired");
      if (!formData.exitCustomsOfficeTransit) newErrors.exitCustomsTransit = t("exitCustomsTransitRequired");
    }

    if (formData.service) {
      if (!formData.route) newErrors.route = t("routeRequired");
      if (!formData.finalClearanceLocation) newErrors.finalClearanceLocation = t("clearanceLocationRequired");

      // Check if at least one file is uploaded for each required document type
      const requiredFiles = getRequiredFiles(t)[formData.service] || [];
      
      for (const fileConfig of requiredFiles) {
        if (fileConfig.required && (!uploadedFiles[fileConfig.key] || uploadedFiles[fileConfig.key].length === 0)) {
          message.error(`${t('pleaseUpload')}: ${t(fileConfig.labelKey)}`);
          return false;
        }
      }
    }

    // Validate terms acceptance
    if (!termsAccepted) {
      newErrors.terms = t("termsRequired");
      message.error(t("termsRequired"));
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    // Create FormData object to handle files
    const formDataToSend = new FormData();

    // Append main fields
    formDataToSend.append('company_name', formData.company_name);
    formDataToSend.append('name', formData.name);
    formDataToSend.append('email', formData.email);
    formDataToSend.append('phone', formData.phone);
    formDataToSend.append('car_number', formData.car_number);
    formDataToSend.append('service', formData.service);
    formDataToSend.append('cargo_price', formData.shipmentPrice); 
    formDataToSend.append('currency', formData.currency); // Added currency to form submission
    formDataToSend.append('route', formData.route); 
    formDataToSend.append('finalClearanceLocation', formData.finalClearanceLocation); 
    formDataToSend.append('exitCustomsOfficeTransit', formData.exitCustomsOfficeTransit); 
    formDataToSend.append('entryCustomsOffice', formData.entryCustomsOffice); 
    formDataToSend.append('exitCustomsOfficeExport', formData.exitCustomsOfficeExport); 
    formDataToSend.append('evaluationCustomsOffice', formData.evaluationCustomsOffice); 

    // Append additional customs data
    const additionalData = {
      evaluationCustomsOffice: formData.evaluationCustomsOffice,
      shipmentPrice: formData.shipmentPrice,
      currency: formData.currency, // Added currency to additional data
    };

    formDataToSend.append('message', formData.message );
    formDataToSend.append('terms_accepted', termsAccepted);

    let fileIndex = 0;
    Object.entries(uploadedFiles).forEach(([docType, files]) => {
      files.forEach((file) => {
        formDataToSend.append(`files[${fileIndex}]`, file);
        formDataToSend.append(`file_types[${fileIndex}]`, docType);
        fileIndex++;
      });
    });

    try {
      const response = await fetch(API_ENDPOINT, {
        method: "POST",
        body: formDataToSend,
        headers: {
          'Accept': 'application/json',
        },
      });

      const data = await response.json();

      if (response.ok) {
        setSuccessModalVisible(true);
        setStatus(t("status"));

        // Reset form
        setFormData({
          company_name: "",
          name: "",
          email: "",
          phone: "",
          car_number: "",
          service: "",
          shipmentPrice: "",
          currency: "", // Reset currency
          evaluationCustomsOffice: "",
          exitCustomsOfficeExport: "",
          entryCustomsOffice: "",
          exitCustomsOfficeTransit: "",
          route: "",
          finalClearanceLocation: "",
          message: "",
        });
        setUploadedFiles({});
        setErrors({});
        setTermsAccepted(false); // Reset terms checkbox

        // Reset all file inputs
        Object.keys(fileInputRefs.current).forEach(key => {
          if (fileInputRefs.current[key]) {
            fileInputRefs.current[key].value = '';
          }
        });
      } else {
        // Handle validation errors from backend
        if (data.errors) {
          setErrors(data.errors);
          const errorMessages = Object.values(data.errors).flat();
          errorMessages.forEach(err => message.error(err));
        } else {
          message.error(data.message || t("error"));
        }
        setStatus(t("error"));
      }
    } catch (error) {
      console.error("Error:", error);
      message.error(t("error"));
      setStatus(t("error"));
    } finally {
      setIsSubmitting(false);
    }
  };

  const renderRequiredFiles = () => {
    if (!formData.service) return null;

    const requiredFiles = getRequiredFiles(t)[formData.service] || [];

    return (
      <div className={styles.fileUploadGrid}>
        {requiredFiles.map(fileConfig => {
          const filesForType = uploadedFiles[fileConfig.key] || [];
          const totalSize = filesForType.reduce((sum, file) => sum + file.size, 0);
          
          return (
            <div key={fileConfig.key} className={styles.fileUploadItem}>
              <label className={styles.fileLabel}>
                {t(fileConfig.labelKey)} {fileConfig.required && <span className={styles.required}>*</span>}
                {filesForType.length > 0 && (
                  <span className={`${styles.fileCount} ${styles.fadeIn}`}>
                    <span className={styles.fileCountBadge}>{filesForType.length}</span>
                    <span className={styles.fileCountText}>{t('files')}, {formatFileSize(totalSize)}</span>
                  </span>
                )}
              </label>
              
              <div className={styles.fileInputWrapper}>
                <input
                  ref={el => fileInputRefs.current[fileConfig.key] = el}
                  type="file"
                  multiple
                  onChange={(e) => handleFileChange(fileConfig.key, e)}
                  className={styles.fileInput}
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg"
                  id={`file-${fileConfig.key}`}
                />
                <label htmlFor={`file-${fileConfig.key}`} className={styles.fileUploadButton}>
                  <svg className={styles.uploadIcon} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path>
                  </svg>
                  <span>{t('selectFiles')}</span>
                  <div className={styles.ripple}></div>
                </label>
                
                {filesForType.length > 0 && (
                  <div className={`${styles.uploadedFilesContainer} ${styles.slideIn}`}>
                    <div className={styles.filesHeader}>
                      <span className={styles.filesTitle}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                          <polyline points="13 2 13 9 20 9"></polyline>
                        </svg>
                        {t('uploadedFiles')}:
                      </span>
                      <button
                        type="button"
                        onClick={() => removeAllFiles(fileConfig.key)}
                        className={styles.removeAllButton}
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <polyline points="3 6 5 6 21 6"></polyline>
                          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                        </svg>
                        {t('removeAll')}
                      </button>
                    </div>
                    
                    <div className={styles.filesList}>
                      {filesForType.map((file, index) => {
                        const animKey = `${fileConfig.key}_${file.uniqueId}`;
                        const animClass = animatingFiles[animKey];
                        
                        return (
                          <div 
                            key={file.uniqueId || index} 
                            className={`
                              ${styles.uploadedFileInfo}
                              ${animClass === 'adding' ? styles.fileAdding : ''}
                              ${animClass === 'removing' ? styles.fileRemoving : ''}
                              ${animClass === 'removing-all' ? styles.fileRemovingAll : ''}
                            `}
                          >
                            <div className={styles.fileIcon}>
                              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                <polyline points="14 2 14 8 20 8"></polyline>
                                <line x1="16" y1="13" x2="8" y2="13"></line>
                                <line x1="16" y1="17" x2="8" y2="17"></line>
                                <polyline points="10 9 9 9 8 9"></polyline>
                              </svg>
                            </div>
                            <div className={styles.fileDetails}>
                              <span className={styles.fileName} title={file.name}>
                                {file.name}
                              </span>
                              <span className={styles.fileSize}>
                                {formatFileSize(file.size)}
                              </span>
                            </div>
                            <button
                              type="button"
                              onClick={() => removeFile(fileConfig.key, index)}
                              className={styles.removeFile}
                              title={t('removeFile')}
                            >
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                              </svg>
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className={styles.packagesDiv} id='contact'>
      <h1 className={styles.title}>{t("contactTitle")}</h1>
      <div className={styles.container}>
        <div className={styles.imageContainer}>
          <img src={Services} alt="Services" />
          <div className={styles.imageOverlay}></div>
        </div>

        <div className={styles.containerChild}>
          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.formGroup}>
              <input
                type="text"
                name="company_name"
                placeholder={t("input1")}
                value={formData.company_name}
                onChange={handleChange}
                required
                className={styles.input}
              />
              {errors.company_name && <span className={styles.error}>{errors.company_name}</span>}
            </div>

            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <input
                  type="text"
                  name="name"
                  placeholder={t("input2")}
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className={styles.input}
                />
                {errors.name && <span className={styles.error}>{errors.name}</span>}
              </div>

              <div className={styles.formGroup}>
                <input
                  type="email"
                  name="email"
                  placeholder={t("input3")}
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className={styles.input}
                />
                {errors.email && <span className={styles.error}>{errors.email}</span>}
              </div>
            </div>

            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <input
                  type="tel"
                  name="phone"
                  placeholder={t("phoneNumber")}
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className={styles.input}
                />
                {errors.phone && <span className={styles.error}>{errors.phone}</span>}
              </div>

              <div className={styles.formGroup}>
                <input
                  type="text"
                  name="car_number"
                  placeholder={t("vehicleNumber")}
                  value={formData.car_number}
                  onChange={handleChange}
                  required
                  className={styles.input}
                />
                {errors.car_number && <span className={styles.error}>{errors.car_number}</span>}
              </div>
            </div>

            {/* Shipment Price and Currency Row */}
            <div className={styles.formRow}>
              <div className={styles.formGroup} style={{ flex: 2 }}>
                <input
                  type="text"
                  name="shipmentPrice"
                  placeholder={t("shipmentPrice")}
                  value={formData.shipmentPrice}
                  onChange={handleChange}
                  required
                  className={styles.input}
                />
                {errors.shipmentPrice && <span className={styles.error}>{errors.shipmentPrice}</span>}
              </div>
              
              <div className={styles.formGroup} style={{ flex: 1 }}>
                <select
                  name="currency"
                  value={formData.currency}
                  onChange={handleChange}
                  required
                  className={styles.select}
                >
                  <option value="">{t("selectCurrency")}</option>
                  {CURRENCIES.map(currency => (
                    <option key={currency.code} value={currency.code}>
                      {currency.symbol} {currency.code}
                    </option>
                  ))}
                </select>
                {errors.currency && <span className={styles.error}>{errors.currency}</span>}
              </div>
            </div>

            <div className={styles.formGroup}>
              <select
                name="service"
                value={formData.service}
                onChange={handleChange}
                required
                className={styles.select}
              >
                <option value="">{t("selectService")}</option>
                <option value="transit">{t("transit")} (T1)</option>
                <option value="export">{t("export")} (T1)</option>
              </select>
              {errors.service && <span className={styles.error}>{errors.service}</span>}
            </div>

            {/* Export specific fields */}
            {formData.service === 'export' && (
              <>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <select
                      name="evaluationCustomsOffice"
                      value={formData.evaluationCustomsOffice}
                      onChange={handleChange}
                      required
                      className={styles.select}
                    >
                      <option value="">{t("evaluationCustomsOffice")}</option>
                      {CUSTOMS_OFFICES.departure.map(office => (
                        <option key={office.code} value={`${office.code} - ${office.name}`}>
                          {office.code} - {office.name}
                        </option>
                      ))}
                    </select>
                    {errors.evaluationCustomsOffice && <span className={styles.error}>{errors.evaluationCustomsOffice}</span>}
                  </div>

                  <div className={styles.formGroup}>
                    <select
                      name="exitCustomsOfficeExport"
                      value={formData.exitCustomsOfficeExport}
                      onChange={handleChange}
                      required
                      className={styles.select}
                    >
                      <option value="">{t("exitCustomsOfficeExport")}</option>
                      {CUSTOMS_OFFICES.departure.map(office => (
                        <option key={office.code} value={`${office.code} - ${office.name}`}>
                          {office.code} - {office.name}
                        </option>
                      ))}
                    </select>
                    {errors.exitCustomsOfficeExport && <span className={styles.error}>{errors.exitCustomsOfficeExport}</span>}
                  </div>
                </div>
              </>
            )}

            {/* Transit specific fields */}
            {formData.service === 'transit' && (
              <>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <select
                      name="entryCustomsOffice"
                      value={formData.entryCustomsOffice}
                      onChange={handleChange}
                      required
                      className={styles.select}
                    >
                      <option value="">{t("entryCustomsOffice")}</option>
                      {CUSTOMS_OFFICES.entry.map(office => (
                        <option key={office.code} value={`${office.code} - ${office.name}`}>
                          {office.code} - {office.name}
                        </option>
                      ))}
                    </select>
                    {errors.entryCustomsOffice && <span className={styles.error}>{errors.entryCustomsOffice}</span>}
                  </div>

                  <div className={styles.formGroup}>
                    <select
                      name="exitCustomsOfficeTransit"
                      value={formData.exitCustomsOfficeTransit}
                      onChange={handleChange}
                      required
                      className={styles.select}
                    >
                      <option value="">{t("exitCustomsOfficeTransit")}</option>
                      {CUSTOMS_OFFICES.departure.map(office => (
                        <option key={office.code} value={`${office.code} - ${office.name}`}>
                          {office.code} - {office.name}
                        </option>
                      ))}
                    </select>
                    {errors.exitCustomsOfficeTransit && <span className={styles.error}>{errors.exitCustomsOfficeTransit}</span>}
                  </div>
                </div>
              </>
            )}

            {/* Common fields for both service types */}
            {formData.service && (
              <>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <div className={styles.inputWithInfo}>
                      <input
                        type="text"
                        name="route"
                        placeholder={t("route")}
                        value={formData.route}
                        onChange={handleChange}
                        required
                        className={styles.input}
                      />
                      <button
                        type="button"
                        onClick={showRouteInfo}
                        className={styles.infoButton}
                        title={t("routeInfoTitle")}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <circle cx="12" cy="12" r="10"></circle>
                          <line x1="12" y1="16" x2="12" y2="12"></line>
                          <line x1="12" y1="8" x2="12.01" y2="8"></line>
                        </svg>
                      </button>
                    </div>
                    {errors.route && <span className={styles.error}>{errors.route}</span>}
                  </div>

                  <div className={styles.formGroup}>
                    <input
                      type="text"
                      name="finalClearanceLocation"
                      placeholder={t("finalClearanceLocation")}
                      value={formData.finalClearanceLocation}
                      onChange={handleChange}
                      required
                      className={styles.input}
                    />
                    {errors.finalClearanceLocation && <span className={styles.error}>{errors.finalClearanceLocation}</span>}
                  </div>
                </div>

                {/* Required files section */}
                <div className={styles.requiredFilesSection}>
                  <h3 className={styles.sectionTitle}>{t("requiredDocuments")}</h3>
                  {renderRequiredFiles()}
                </div>
              </>
            )}

            <div className={styles.formGroup}>
              <textarea
                name="message"
                placeholder={t("input7")}
                value={formData.message}
                onChange={handleChange}
                className={styles.textarea}
              ></textarea>
            </div>

            {/* Terms and conditions checkbox */}
            <div className={styles.termsContainer}>
              <label className={styles.termsLabel}>
                <input
                  type="checkbox"
                  checked={termsAccepted}
                  onChange={handleTermsChange}
                  className={styles.termsCheckbox}
                />
                <span className={styles.checkmark}></span>
                <span className={styles.termsText}>
                  {t("acceptTerms")} 
                  <button
                    type="button"
                    onClick={showTermsModal}
                    className={styles.termsLink}
                  >
                    {t("termsAndConditions")}
                  </button>
                </span>
              </label>
              {errors.terms && <span className={styles.error}>{errors.terms}</span>}
            </div>

            <button
              type="submit"
              className={`${styles.submitButton} ${!termsAccepted ? styles.submitButtonDisabled : ''}`}
              disabled={isSubmitting || !termsAccepted}
            >
              {isSubmitting ? (
                <span className={styles.loadingSpinner}>
                  <svg className={styles.spinner} viewBox="0 0 50 50">
                    <circle className={styles.path} cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
                  </svg>
                </span>
              ) : (
                <>
                  {t("send")}
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={styles.sendIcon}>
                    <line x1="22" y1="2" x2="11" y2="13"></line>
                    <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                  </svg>
                </>
              )}
            </button>
          </form>
        </div>
      </div>

      <Modal
        title={t("termsTitle")}
        visible={termsModalVisible}
        onOk={handleTermsModalClose}
        onCancel={handleTermsModalClose}
        width={1090}
        footer={[
          <button key="close" onClick={handleTermsModalClose} className={styles.modalButton}>
            {t("routeInfoButton")}
          </button>
        ]}
      >
        <div className={styles.termsModalContent}>
          <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit' }}>
            {t("termsContent")}
          </pre>
        </div>
      </Modal>

      <Modal
        title={null}
        visible={successModalVisible}
        onCancel={() => setSuccessModalVisible(false)}
        footer={null}
        centered
        width={420}
        closable={false}
      >
        <div className={styles.successModalContent}>
          <div className={styles.successIconWrapper}>
            <svg className={styles.successIcon} viewBox="0 0 52 52" fill="none">
              <circle cx="26" cy="26" r="25" stroke="#52c41a" strokeWidth="2" fill="#f6ffed" />
              <path d="M14 27l9 9 16-18" stroke="#52c41a" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <h2 className={styles.successModalTitle}>{t("successModalTitle")}</h2>
          <p className={styles.successModalCompany}>{t("successModalCompany")}</p>
          <p className={styles.successModalMessage}>{t("successModalMessage")}</p>
          <button onClick={() => setSuccessModalVisible(false)} className={styles.successModalButton}>
            {t("successModalClose")}
          </button>
        </div>
      </Modal>
    </div>
  );
}

export default Packages;